import React from 'react';
import '../../styles/sections.css';
import '../../styles/challenges.css';

const Challenges = () => {
  return (
          <section className="challenges-section">
        <div className="section-header">
          <h2>CHALLENGES</h2>
          <div className="underline"></div>
        </div>
        <div className="challenges-content">
        <ul>
          <li>Integrating React Native with Expo while maintaining native iOS performance and user experience.</li>
          <li>Designing and implementing a scalable Go backend API that efficiently handles concurrent user requests and social media interactions.</li>
          <li>Optimizing PostgreSQL database queries for complex social media operations like feed generation, user connections, and content filtering.</li>
          <li>Managing state synchronization between the React Native frontend and Go backend, especially for real-time features.</li>
          <li>Implementing secure authentication and authorization flows across the mobile app and backend API.</li>
          <li>Implementing the image upload pipeline with AWS Rekognition for content moderation, ensuring proper handling of rejected content and seamless integration with IPFS Pinata for decentralized storage.</li>
          <li>Configuring and optimizing AWS Lambda functions and API Gateway for serverless backend deployment, managing cold starts, timeout limits, and cost optimization.</li>
          <li>Managing database connections and query performance with Neon PostgreSQL, ensuring efficient connection pooling and handling production-scale traffic.</li>
          <li>Coordinating Apple TestFlight beta testing workflows, managing build distribution, and collecting feedback from testers across different iOS versions.</li>
          <li>Ensuring smooth navigation and performance in React Native while managing large datasets and complex UI components.</li>
          <li>Debugging cross-platform compatibility issues and ensuring consistent behavior across different iOS devices and versions.</li>
        </ul>
      </div>
    </section>
  );
};

export default Challenges;

